const server =
  import.meta.env.MODE === 'development'
    ? 'http://localhost:3101'
    : 'https://platform-api.app.kinesis.org';

export { server };
